"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShippingStepFields = void 0;
var _react = _interopRequireDefault(require("react"));
var _lodash = _interopRequireDefault(require("lodash"));
var _core = require("@material-ui/core");
var _formValidators = require("react-platform-components/dist/form-validators");
var _config = require("../../../config");
var _index = require("react-platform-components/dist/form-fields/index");
var _Translations = require("react-platform-components/dist/Translations");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var ShippingField = null;
var SHIPMENT_BY_SELLER_UUIDS;
var CustomShipping = undefined;
var ShippingStepFields = undefined;
exports.ShippingStepFields = ShippingStepFields;
try {
  ShippingField = require("react-platform-shipping/dist/form-fields/ShippingField/ShippingField").ShippingField;
  SHIPMENT_BY_SELLER_UUIDS = require("react-platform-shipping/dist/config/index").SHIPMENT_BY_SELLER_UUIDS;
  CustomShipping = function CustomShipping(_ref) {
    var getFieldName = _ref.getFieldName,
      shippingOptionName = _ref.shippingOptionName;
    return /*#__PURE__*/_react.default.createElement(_core.Grid, {
      container: true,
      spacing: 0
    }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
      variant: "body2",
      className: "pt-1"
    }, shippingOptionName)), /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12,
      md: 12,
      style: {
        paddingBottom: "1rem"
      }
    }, /*#__PURE__*/_react.default.createElement(_index.TextField, {
      name: getFieldName("price"),
      label: "Shipping price",
      margin: "none",
      variant: "outlined",
      fullWidth: true,
      required: true,
      validate: (0, _formValidators.validators)([(0, _formValidators.required)(), (0, _formValidators.number)(), (0, _formValidators.isPositive)()]),
      type: "number"
    })));
  };
  exports.ShippingStepFields = ShippingStepFields = function ShippingStepFields() {
    var _SHIPMENT_BY_SELLER_U;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, ShippingField && /*#__PURE__*/_react.default.createElement(_core.Grid, {
      container: true,
      spacing: 2
    }, /*#__PURE__*/_react.default.createElement(ShippingField, _extends({
      name: "shipping",
      validate: (0, _formValidators.validators)([(0, _formValidators.required)( /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
        id: "le choix d\u2019un mode de livraison est obligatoire"
      }))])
    }, _config.PRODUCT_DEFAULT_WIDTH !== "" ? {
      getWidth: function getWidth() {
        return _config.PRODUCT_DEFAULT_WIDTH;
      }
    } : null, _config.PRODUCT_DEFAULT_HEIGHT !== "" ? {
      getHeight: function getHeight() {
        return _config.PRODUCT_DEFAULT_HEIGHT;
      }
    } : null, _config.PRODUCT_DEFAULT_LENGTH !== "" ? {
      getLength: function getLength() {
        return _config.PRODUCT_DEFAULT_LENGTH;
      }
    } : null, {
      customHandling: (_SHIPMENT_BY_SELLER_U = SHIPMENT_BY_SELLER_UUIDS) === null || _SHIPMENT_BY_SELLER_U === void 0 ? void 0 : _SHIPMENT_BY_SELLER_U.map(function (uuid) {
        return {
          uuid: uuid,
          component: CustomShipping
        };
      })
    }))));
  };
} catch (error) {}